module.exports = __webpack_public_path__ + "img/icom10.4583cb4b.png";